'use client';

import clsx from 'clsx';

import { Alter25Badge } from '@/components/alter25/Alter25Badge';
import { CircleCheck } from '@/components/icons/CircleCheck';

export const SwabKitProductDetailsTitle: React.FC = () => {
  return (
    <>
      <div
        className={clsx(
          'font-light text-alter-black mb-4',
          'text-[24px] leading-[28.8px] tracking-[-0.72px]',
          'sm:text-[27px] sm:leading-[32.6px] sm:tracking-[-.82px]',
          'md:text-[32px] md:leading-[38.9px] md:tracking-[-0.97px]',
          'lg:text-[40px] lg:leading-[48px] lg:tracking-[-1.2px]'
        )}
      >
        DNA Fitness & Health Report
      </div>

      <div className="flex flex-wrap justify-start items-center gap-2 mb-4">
        <Alter25Badge
          darkText="HSA/FSA"
          lightText="Eligible"
          icon={<CircleCheck className="text-alter-black w-[18px] h-[18px] tracking-[-0.48px]" />}
        />
        <Alter25Badge
          darkText="200,000+"
          lightText="Traits in 2024"
          icon={<CircleCheck className="text-alter-black w-[18px] h-[18px]" />}
        />
      </div>
    </>
  );
};
